import { useState } from 'react';
import './App.css';

// Import all components
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesBar from './components/FeaturesBar';
import About from './components/About';
import Products from './components/Products';
import Gallery from './components/Gallery';
import OrderForm from './components/OrderForm';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  // State to store form data
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    product: '',
    quantity: '',
    message: ''
  });

  // Updates state when user types
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handles form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Stops page from refreshing
    
    // Create WhatsApp message
    const whatsappMessage = `Hello Motif Farms!%0A%0AName: ${formData.name}%0APhone: ${formData.phone}%0AProduct: ${formData.product}%0AQuantity: ${formData.quantity}%0AMessage: ${formData.message}`;
    
    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/233557455228?text=${whatsappMessage}`, '_blank');
  };

  return (
    <div className="App bg-background-light dark:bg-background-dark text-[#111811] dark:text-gray-100 font-display transition-colors duration-300">

      {/* Navigation Header */}
      <Header />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <Hero />

        {/* Features Bar */}
        <FeaturesBar />

        {/* About Section */}
        <About />

        {/* Products Section */}
        <Products />

        {/* Gallery Section */}
        <Gallery />

        {/* Order/Contact Form */}
        <OrderForm />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      <WhatsAppButton />

    </div>
  );
}

export default App;
